import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Button from 'portal-modules/common/components/Button'
import { RpModal } from 'portal-modules/common/components/modals'
import {
  StyledFlexModalBtn,
  StyledFlexModalText,
  StyledFlexModalFooterText ,
  StyledFlexModalButton,
  StyledFlexModalTextFontWeight,
  StyledFlexModalTitle,
  StyledFlexModalTextFont,
  StyledFlexModaldiv,
  StyledFlexModalImage,
  StyledFlexTextColor,
  StyledImage
} from './atoms'
import { PAYMENTS } from 'portal-modules/payments/constants/urls'
import { FlexPayTitle } from 'App/../public/svg'
import fleximage from 'App/../public/images/fleximage.png'
import { connect } from 'react-redux'

const handleLearnClick = () => {
  window.location.href = PAYMENTS.FLEX_LEARN_MORE
}
const TryFlexPayModal = ({ show, setShow, user, isLeaseAndRentWordReplaced = false }) => {
  const closeModal = () => {
    setShow(false)
  }
  const handleClick = (user) => {
    window.open(PAYMENTS.QUICK_LINK_PAY)
    setShow(false)
    if (typeof newrelic == 'object') {
      newrelic.addPageAction('ContinueToFlexPay', { cid: user.cid, customerId: user.customerId, leaseId: user.leaseId, propertyId: user.propertyId });
    }
  }
  const rentReplacedText = isLeaseAndRentWordReplaced ? 'your housing fee' : 'rent'
  return (
    <RpModal
      show={show}
      onClose={closeModal}
      ContentDivHeight='500px'
      isfromFlexModal={true}
      footerContent={
        <Fragment>
        <StyledFlexModalFooterText>
       {__(
         'Entrata is proud to be a Flex partner. You will be redirected to a third-party website if you continue.',
       )}
     </StyledFlexModalFooterText>
        <StyledFlexModalBtn>
          <Button
            appearance='primary'
            size='medium'
            onClick={()=>handleClick(user)}
            css={StyledFlexModalButton}
            className={'track-pendo-flex-ql'}
          >
            {__('Continue to Flex')}
          </Button>
          <Button
            appearance='secondary'
            size='medium'
            css={StyledFlexModalButton}
            onClick={closeModal}
          >
            {__('Cancel')}
          </Button>
        </StyledFlexModalBtn>
        </Fragment>
      }
    >
       <StyledFlexModaldiv>
       <StyledFlexModalTitle>
        <img src={FlexPayTitle} />
            <StyledFlexModalText css={StyledFlexModalTextFont}>
        {__(
                'Split {%s, 0} into ', [rentReplacedText]
        )}
              <StyledFlexTextColor css={StyledFlexModalTextFont}>
                {__(
                'two payments. ',
                )}
              </StyledFlexTextColor>
      </StyledFlexModalText>
      <StyledFlexModalText css={StyledFlexModalTextFontWeight}>
              {__(
                'Flex is a monthly subscription that helps you pay {%s, 0} on time, improve cash flow, and build your credit history.', [rentReplacedText]
              )}
      </StyledFlexModalText>

        </StyledFlexModalTitle>
        <StyledFlexModalImage>
         <StyledImage src={fleximage} />
        </StyledFlexModalImage>
      </StyledFlexModaldiv>

    </RpModal>
  )
}

TryFlexPayModal.PropTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  isLeaseAndRentWordReplaced: PropTypes.bool
}
export default connect(
  ({ productPermissions: { replace_lease_and_rent }, propertyAssociation }) => ({
    isLeaseAndRentWordReplaced: replace_lease_and_rent || propertyAssociation?.resident_portal?.replace_lease_and_rent || false,
  }),
)(TryFlexPayModal)
